import { CommonContentMessage } from "../types";

const GENERATION_SENDERS = ["generate_text", "generate_json"];

// A generation interaction's sender alone doesn't mean model output: it also
// sends user-sourced feedback when a generation comes back invalid.
export const isGeneratedContent = (message: CommonContentMessage): boolean =>
  message.source === "assistant" && GENERATION_SENDERS.includes(message.sender);
